<template>
  <WhitePage :loading="loading">
    <title-bar>異世界一覧</title-bar>
    <!-- <action-nav /> -->
    <p>
      創造した異世界の一覧です。スポットを作成すると異世界が創造可能になります。
    </p>

    <p class="link-world">
      <b-table-simple hover small>
        <b-thead>
          <b-tr>
            <b-th>異世界名</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr variant="light" v-for="(w,index) in world" :key="index">
            <b-td>
              <!-- <b-button class="p-1" @click="$delete(world, index)">
                <font-awesome-icon icon="times" class="fa-1x" />
              </b-button> -->
              <router-link :to="{ path:`world-edit/${index}` }">
                {{ w.name }}
                <font-awesome-icon icon="pen" class="icon fa-sx" />
              </router-link>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </p>

    <b-button @click="$router.push('/world-edit/new')"
      :disabled="!enabledMakeWorld"
    >
      <font-awesome-icon icon="plus-square" class="icon fa-1x" />
      新規異世界創造
    </b-button>
    <pagenate>
      <template #previous>
        <b-icon icon="chevron-left" />
        <router-link to="/spot">スポット</router-link>
      </template>
    </pagenate>
  </WhitePage>
</template>
'
<script>
// import phina from 'phina.js'
import store from '@/store'
import WhitePage from '@/components/WhitePage'
import CheckLogin from '@/components/mixin-checkLogin'
import TitleBar from '@/components/TitleBar'
// import ActionNav from '@/components/ActionNav'
import _ from 'lodash'
import Pagenate from '@/components/Pagenate'
export default {
  components: {
    WhitePage,
    TitleBar,
    // ActionNav,
    Pagenate
  },
  computed: {
    enabledMakeWorld () {
      return this.haveSpot && _.keys(this.world).length < this.maxMyWorld
    }
  },
  data () {
    return {
      world: {},
      haveSpot: false,
      loading: false,
      maxMyWorld: 0,
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
      this.world = response.world
      this.haveSpot = !!response.haveSpot
      this.maxMyWorld = Number.parseInt(response.maxWorld)
    },
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getMyWorld')
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    this.checkLogin()
  },
  mounted () {
    // phina.global.app.currentScene.exit('MainScene')
  }
}
</script>

<style lang="scss" scoped>
</style>
